import { useEffect, useState } from 'react';
import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { searchSenders, type TSenderSearch } from '../../entities/auth-preset';

const PAGE = 7;

/** `keepPreviousData` is load-bearing: without it every keystroke empties the list. */
export const useSenderSearch = (query: string): UseQueryResult<TSenderSearch> => {
  const [settled, setSettled] = useState(query);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(query), 180);
    return () => clearTimeout(timer);
  }, [query]);

  return useQuery({
    queryKey: ['sender-search', settled.trim()],
    queryFn: () => searchSenders(settled.trim(), PAGE),
    placeholderData: keepPreviousData,
  });
};
